import React, { useMemo, useState } from "react";
import {Name, GetLink, Active, Options} from "../Areas/AreaCol";

const useBrochureCols = () => {
    return useMemo(() => [
        {
            Header: "Nombre de archivo",
            accessor: "file_name",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Status",
            accessor: "status",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Usuario que solicitó",
            accessor: "user_name",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Fecha de solicitud",
            accessor: "created_at_f",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Link de descarga",
            accessor: "fill_path_full",
            filterable: false,
            Cell: (cellProps) => {
                return <GetLink {...cellProps} />;
            },
        }
    ],[]);  
}
export {useBrochureCols}